import * as React from "react";

import type { ActivityContentResourceHubFolderCopied } from "@/api";
import type { Activity } from "@/models/activities";
import type { ActivityHandler } from "../interfaces";

import { feedTitle, folderLink } from "../feedItemLinks";
import { resourceHubFolderPathOrParent, visibleParentDescriptor } from "../resourceHubActivity";

const ResourceHubFolderCopied: ActivityHandler = {
  pageHtmlTitle(_activity: Activity) {
    throw new Error("Not implemented");
  },

  pagePath(paths, activity: Activity): string {
    const data = content(activity);

    return resourceHubFolderPathOrParent(paths, data.folder, data);
  },

  PageTitle(_props: { activity: any }) {
    throw new Error("Not implemented");
  },

  PageContent(_props: { activity: Activity }) {
    throw new Error("Not implemented");
  },

  PageOptions(_props: { activity: Activity }) {
    return null;
  },

  FeedItemTitle({ activity, page }: { activity: Activity; page: any }) {
    const data = content(activity);
    const folder = data.folder ? folderLink(data.folder) : "папка";
    const originalFolder = data.originalFolder ? folderLink(data.originalFolder) : "папка";
    const parent = visibleParentDescriptor(page, data);

    if (!parent) {
      return feedTitle(activity, "создал(а) копию", originalFolder, "папку и назвал(а)", folder);
    }

    return feedTitle(
      activity,
      "создал(а) копию",
      originalFolder,
      "папку в",
      parent.link,
      parent.label,
      "и назвал(а)",
      folder,
    );
  },

  FeedItemContent({}: { activity: Activity }) {
    return <></>;
  },

  feedItemAlignment(_activity: Activity): "items-start" | "items-center" {
    return "items-start";
  },

  commentCount(_activity: Activity): number {
    throw new Error("Not implemented");
  },

  hasComments(_activity: Activity): boolean {
    throw new Error("Not implemented");
  },

  NotificationTitle({ activity }: { activity: Activity }) {
    return "Создана копия папки: " + (content(activity).folder?.name ?? "папка");
  },

  NotificationLocation({ activity }: { activity: Activity }) {
    return content(activity).folder?.name ?? null;
  },
};

function content(activity: Activity): ActivityContentResourceHubFolderCopied {
  return activity.content as ActivityContentResourceHubFolderCopied;
}

export default ResourceHubFolderCopied;
